export default __webpack_public_path__ + "228db07e6c7037db8f304ae047d8d2cb.png";